import { Component } from '@angular/core';
import { ScadenzarioListRinviiComponent } from '../../../form/scadenzario/scadenzario-list-rinvii.component';


import { Rinvio } from '../../../models/rinvio';


@Component({
    selector: 'div [scadenzario-list-rinvii]',
  templateUrl: '../../../form/scadenzario/scadenzario-list-rinvii.component.html',
  host: { '[class.col-sm-12]': '\'true\'', '[class.coldx]': '\'true\'' }
})

export class ScadenzaListRinviiConcreteFormComponent extends ScadenzarioListRinviiComponent {
  rinviiScadenza: Rinvio[];

  getRinviiScadenza() {
    return this.rinviiScadenza;
  }

  inizializza(rinviiScadenza: Rinvio[]) {
    this.rinviiScadenza = rinviiScadenza;
    this.inizializzaMod();
  }
}
